import * as React from 'react';
import { SVGProps } from 'react';

const IconPinSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m11.674 2.279 2.048 2.054c.37.372.37.975 0 1.346l-3.264 3.274.082.146c.617 1.115.491 2.573-.408 3.475L8.71 14l-2.684-2.692L2.671 14 2 13.327l2.684-3.365L2 7.27l1.422-1.426c.899-.902 2.388-.993 3.5-.373l.146.081 3.264-3.273a.947.947 0 0 1 1.341 0Z"
    />
  </svg>
);
export default IconPinSizeS;
